import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Langs from "../../app/lang/langs";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import ImageButton from "../../components/buttons/ImageButton";
import AddTeamManagersModal from "./AddTeamManagersModal";
import { getTeamsManagers, setTeamManagers, removeTeamManager } from "../../components/teams/teamsSlice";
import { Col, Row } from "react-bootstrap";
import deleteIcon from "../../assets/images/delete.png";
import deleteIconFocus from "../../assets/images/delete-orange.png";
import { showErrorToast } from "../../app/utils/helpers";

export default function ManagersListModal(props) {

    const dispatch = useDispatch()
    const managersList = useSelector((state) => state.teams.teamManagers)
    const [addModalVisibility, setAddModalVisibility] = useState(false)

    useEffect(() => {
        if (props && props.visible && props.idTeam) {
            dispatch(getTeamsManagers({ id_team: props.idTeam }))
        } else {
            dispatch(setTeamManagers([]))
        }
    }, [props])

    const handleRemoveManager = async (manager) => {
        if (!props.idTeam || !manager.id_collab) return;

        const data = {
            id_team: props.idTeam,
            id_collab: manager.id_collab,
        };

        try {
            const response = await dispatch(removeTeamManager(data));

            if (response.payload.responseData && response.payload.responseData.status === 1) {
                const updatedManagers = managersList.filter((m) => m.id_collab !== manager.id_collab);
                dispatch(setTeamManagers(updatedManagers));
            } else {
                showErrorToast(response.payload?.message || "Failed to remove manager");
            }
        } catch (error) {
            console.error("Error removing manager:", error);
            showErrorToast("An error occurred while removing the manager");
        }
    };

    const modalHeader = () => {
        return (
            <div>
                <Row>
                    <Col md={1}>
                        <ImageButton
                            image={addIcon}
                            imageFocus={addIconFocus}
                            onClick={() => { setAddModalVisibility(true) }}
                            active={true}
                            tooltip={<Langs str="ADD_MANAGERS" />}
                            width={32} /></Col>
                    <Col className="align-content-center">
                        {props.teamName}
                    </Col>
                </Row>
            </div>
        )
    }

    return (
        <Dialog
            visible={props.visible}
            style={{ width: 'fit-content', height: "100vh", maxHeight: "100%", marginRight: 0 }}
            onHide={() => { if (!props.visible) return; props.setVisible(false); }}
            position="right"
            draggable={false}
            dismissableMask={true}
            header={modalHeader}
        >
            <DataTable value={managersList}
                tableStyle={{ maxWidth: '30rem' }}
                scrollable
                scrollHeight="calc(85vh)"
                draggable={false}
            >
                <Column sortable field="prenom" header={<Langs str="prenom" />}></Column>
                <Column sortable field="nom" header={<Langs str="nom" />}></Column>
                <Column sortable style={{ minWidth: "18rem" }} field="email" header={<Langs str="email" />}></Column>
                <Column field="type" header={<Langs str="TYPE" />}></Column>
                <Column
                    field="actions"
                    body={(rowData) => (
                        <Col className="d-flex justify-content-center">
                            <ImageButton
                                image={deleteIcon}
                                imageFocus={deleteIconFocus}
                                onClick={() => handleRemoveManager(rowData)}
                                active={true}
                                tooltip={<Langs str="REMOVE_MANAGER" />}
                                width={20}
                            />
                        </Col>
                    )}
                />
            </DataTable>
            <AddTeamManagersModal
                visible={addModalVisibility}
                setVisible={setAddModalVisibility}
                prevManagers={managersList}
                idTeam={props.idTeam}
            />
        </Dialog>
    )
}